export type ValidationResults = {
  warnings:  { [fieldName: string]: string[] };
  errors: { [fieldName: string]: string[] };
  isValid: boolean;
};

export type Validator = {
  isValid: () => boolean;
  getErrors: () => { [fieldName: string]: string[] };
  getWarnings: () => { [fieldName: string]: string[] };
};

export type ValidationFn<T> = (...args: T[]) => Validator;

/**
 * Validates an item or arr of items using the passed validation function.
 * Will return an object with an errors and warnings list if validation checks are not passed.
 *
 * This function serves as an abstraction layer between the validation itself and the validation library chosen:
 * Any validation function that returns a list of errors using getErrors() and a list of warnings using getWarnings()
 * will serve as a validation function.
 *
 * The intent is to use this with VestJS, but another validation library could be used if desired.
 * @param validateFn
 * @param target
 */
export const validate = <T>(
  validateFn: ValidationFn<T>,
  target: T,
): ValidationResults => {
  const validator = validateFn(target);

  return {
    errors: validator.getErrors(),
    isValid: validator.isValid(),
    warnings: validator.getWarnings(),
  };
};
